import {
  Option,
  ProviderFiltersType,
  ProviderSearchFilters,
} from '../../models/ProviderSearch';
import { FilterCollectionModel } from '../Constants';

/**
 * Applies BCC (Priority Scheduling) filter auto-select logic to the selected filters.
 * When BCC is enabled, automatically selects "Next 7 days" in the Upcoming Availability filter.
 * When BCC is disabled, automatically deselects "Next 7 days" from the Upcoming Availability filter.
 *
 * @param selectedFilters - The current selected filters
 * @param providerFilters - Available provider filters or provider filter list (can be array or object)
 * @param bccFilter - The BCC filter value (can be boolean, Option, array, undefined, or null)
 * @returns Updated filters with BCC auto-select logic applied
 */
export const applyBccAutoSelectLogic = (
  selectedFilters: ProviderSearchFilters,
  providerFilters: ProviderFiltersType[] | any,
  bccFilter: boolean | Option | Option[] | undefined | null
): ProviderSearchFilters => {
  let bccEnabled = false;

  if (bccFilter == null) {
    bccEnabled = false;
  } else if (typeof bccFilter === 'boolean') {
    bccEnabled = bccFilter;
  } else if (Array.isArray(bccFilter)) {
    bccEnabled = bccFilter.length > 0;
  } else if (typeof bccFilter === 'object' && 'value' in bccFilter) {
    bccEnabled = (bccFilter as Option).value === true;
  }
  const updatedFilters = { ...selectedFilters };

  const upcomingAvailabilityFilter = Array.isArray(providerFilters)
    ? providerFilters.find(
        (filter) => filter.model === FilterCollectionModel.UPCOMING_AVAILABILITY
      )
    : providerFilters?.UpcomingAvailability;

  const has7DayOption = upcomingAvailabilityFilter?.options?.some(
    (option) => String(option.value) === '7'
  );

  if (bccEnabled && has7DayOption && upcomingAvailabilityFilter) {
    const sevenDayOption = upcomingAvailabilityFilter.options.find(
      (option) => String(option.value) === '7'
    );
    if (sevenDayOption) {
      updatedFilters[FilterCollectionModel.UPCOMING_AVAILABILITY] = [
        sevenDayOption,
      ];
    }
  } else if (!bccEnabled) {
    const currentUpcomingAvailability =
      selectedFilters[FilterCollectionModel.UPCOMING_AVAILABILITY];
    if (Array.isArray(currentUpcomingAvailability)) {
      const filtered = currentUpcomingAvailability.filter(
        (option) => String(option.value) !== '7'
      );
      updatedFilters[FilterCollectionModel.UPCOMING_AVAILABILITY] =
        filtered.length > 0 ? filtered : [];
    }
  }

  return updatedFilters;
};
